import InnerComponent from '@Components/Sales/Consumption/ConsumptionForm';
import orgContainer from '@Components/AppContainer';

const CreateConsumption = () => ((orgContainer(InnerComponent)));
export default CreateConsumption;